import type { MetaRoleType } from "../../contracts/utils/metadata/MetaRoleType";
import type { MetadataApiSpecInfo as MetadataApiSpecInfoContract } from "../../contracts/utils/metadata/MetadataApiSpecInfo";
import type { RequestMethod } from "../../types/RequestMethod";

export class MetadataApiSpecInfo implements MetadataApiSpecInfoContract {
	constructor(
		private options: {
			doc_url: string;
			name: string;
			title: string;
			role: MetaRoleType[];
			method: RequestMethod;
			endpoint: string;
			deprecated: boolean;
			entity_path: string;
		},
	) {}

	get doc_url(): string {
		return this.options.doc_url;
	}

	get name(): string {
		return this.options.name;
	}

	get title(): string {
		return this.options.title;
	}

	get role(): MetaRoleType[] {
		return [...this.options.role];
	}

	get method(): RequestMethod {
		return this.options.method;
	}

	get endpoint(): string {
		return this.options.endpoint;
	}

	get deprecated(): boolean {
		return this.options.deprecated;
	}

	get entity_path(): string {
		return this.options.entity_path;
	}
}
